import classNames from 'classnames';

const CustomInput = ({
  customInput,
  setCustomInput,
}: {
  customInput: string;
  setCustomInput: (value: string) => void;
}) => {
  return (
    <>
      {' '}
      <textarea
        rows={5}
        value={customInput}
        onChange={(e) => setCustomInput(e.target.value)}
        placeholder={`Enter your inputs here, (Each input in a separate line)`}
        className={classNames(
          'focus:outline-none w-full border-2 border-black z-10 rounded-md shadow-[5px_5px_0px_0px_rgba(0,0,0)] px-4 py-2 hover:shadow transition duration-200 bg-white mt-2'
        )}
      ></textarea>
    </>
  );
};

export default CustomInput;
